import { useCallback, useEffect, useState } from 'react';
import { api } from './api';

export function useApi<T>(path: string | null, fallback: T) {
  const [data, setData] = useState<T>(fallback);
  const [loading, setLoading] = useState(Boolean(path));
  const [error, setError] = useState('');
  const refresh = useCallback(async () => {
    if (!path) return;
    try { setData(await api<T>(path)); setError(''); }
    catch (err) { setError(err instanceof Error ? err.message : '加载失败'); }
    finally { setLoading(false); }
  }, [path]);
  useEffect(() => { void refresh(); }, [refresh]);
  return { data, loading, error, refresh, setData };
}

export function useLiveRefresh(refresh: () => Promise<void> | void) {
  useEffect(() => {
    const source = new EventSource('/api/public/stream');
    const update = () => void refresh();
    source.addEventListener('strategy.summary.updated', update);
    source.addEventListener('account.connection.changed', update);
    const fallback = window.setInterval(update, 30_000);
    return () => { source.close(); window.clearInterval(fallback); };
  }, [refresh]);
}
